class StickyVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.initCustomSelects();
    this.onMainChange();
  }
  initCustomSelects() {
    let addToCartSubbmit = document.querySelector('product-payment-container .product-form__submit');
    let addToCartButton = document.querySelector('.add_to_cart');
    let addtoCartAddText = addToCartButton.querySelector('.add_to_cart_with_select');
    let addtocartSoloutText = addToCartButton.querySelector('.add_to_cart_with_select_soldout');
    let addToCartLoadingSvg = addToCartButton.querySelector('.loading_svg');
    this.querySelectorAll('select.js-sticky-variants').forEach(select => {
      let selectOptions = select.children.length;
      select.classList.add('hidden');
      
      let wrapper = document.createElement('div');
      select.parentNode.insertBefore(wrapper, select);
      wrapper.appendChild(select);
      
      let customSelect = document.createElement('div');
      customSelect.classList.add('custom-select', "visually-hidden");
      
      let selectedOption = select.options[select.selectedIndex];
      customSelect.textContent = selectedOption.textContent;
      if (selectedOption.selected) {
        select.classList.add('selected');
        selectedOption.setAttribute('selected', 'selected');
      }
      wrapper.appendChild(customSelect);
      
      let optionList = document.createElement('ul');
      optionList.classList.add('select-options');
      optionList.classList.add('sticky-variants-select');
      optionList.style.display = 'none';
      wrapper.appendChild(optionList);
      
      for (let i = 0; i < selectOptions; i++) {
        let optionItem = document.createElement('li');
        optionItem.textContent = select.children[i].textContent;
        optionItem.setAttribute('rel', select.children[i].value);
        optionItem.setAttribute('data-value', select.children[i].value);
          if(optionItem.textContent.includes("-")){
            optionItem.classList.add('out-of-stock');
          }
        if (select.children[i].selected) {
          optionItem.classList.add('active', 'selected');
        }
        
        optionList.appendChild(optionItem);
      }

      const sizeChart = document.querySelector('.size-guide-chart');
      if(sizeChart){
        optionList.appendChild(sizeChart); 
        sizeChart.classList.remove('visually-hidden');   
      }
      let optionItems = optionList.querySelectorAll('li');
      
      addToCartButton.addEventListener('click', (e) => {
        e.stopPropagation();
        
        document.querySelectorAll('.custom-select.active').forEach(activeSelect => {
          if (activeSelect !== customSelect) {
            activeSelect.classList.remove('active');
            activeSelect.nextElementSibling.style.display = 'none';
          }
        });
        
        customSelect.classList.toggle('active');
        optionList.style.display = optionList.style.display === 'flex' ? 'none' : 'flex';
        select.classList.toggle('active');
      });
      
      optionItems.forEach((item, index) => {
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          
          optionItems.forEach(li => {
            li.classList.remove('active', 'selected');
          });
          item.classList.add('active', 'selected');
          
          customSelect.textContent = item.textContent;
          
          // Update the original select and trigger change
          select.selectedIndex = index;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          
          customSelect.classList.remove('active');
          optionList.style.display = 'none';
          const variantData =  JSON.parse(this.querySelector('[type="application/json"]').textContent);
          const valueOption = item.textContent.trim();
              variantData.forEach(variant => {
                variant.options.forEach(option => {
                  
                  if(valueOption == option){
                    addToCartLoadingSvg.classList.remove('hidden');
                    addToCartButton.style.pointerEvents = 'none';
                      const productForm = document.querySelector('product-payment-container product-form');

                      productForm.onSubmitHandler(new Event('submit'));
   
                    this.renderProductInfo();
                    // addToCartSubbmit.dispatchEvent(new Event('click', { bubbles: true }));
                      // Find the submit button inside the product-form

                    // setTimeout(() => {
                    //   addToCartSubbmit.click();
                    // }, 1000);
                    setTimeout(() => {
                      addToCartLoadingSvg.classList.add('hidden');
                      addToCartButton.style.pointerEvents = 'auto';
                    }, 1700);
                    if(variant.available){
                      addToCartButton.removeAttribute('disabled');
                      addtoCartAddText.classList.remove("hidden");
                      addtocartSoloutText.classList.add("hidden");
                    }
                  }
                  else if (valueOption.includes("-")){
                    if(!variant.available){
                      addToCartButton.setAttribute('disabled', 'disabled');
                      addtoCartAddText.classList.add("hidden");
                      addtocartSoloutText.classList.remove("hidden");
                    }
                  }
                })
              });
        });
      });
      
      document.addEventListener('click', () => {
        customSelect.classList.remove('active');
        optionList.style.display = 'none';
        select.classList.remove('active');
      });
    });

  }
  onMainChange() {
    const sticky = document.querySelector(".product-sticky-form__inner .select-options");
    let main_select = document.querySelector(".product-parameters variant-selects select");
    let sticky_select = document.querySelector("sticky-variant-selects variant-selects select");
    let addToCartButton = document.querySelector('.add_to_cart');
    let addtoCartAddText = addToCartButton.querySelector('.add_to_cart_with_select');
    let addtocartSoloutText = addToCartButton.querySelector('.add_to_cart_with_select_soldout');
    let  selectedID= "";
    let isStickyChange = false; 
    if (!sticky) return;
    if (sticky_select) {
      sticky_select.addEventListener("change", () => {
          isStickyChange = true;
          return; 
      });
    }
    main_select.addEventListener("change", (event) => { 
      const selectedValue = event.target.value;
      console.log(selectedValue);
      
      const optionItems = sticky.querySelectorAll("li");
      optionItems.forEach((item) => {
          if (item.getAttribute("rel") === selectedValue) { 
              item.classList.add("active", "selected");
          } else {
              item.classList.remove("active", "selected");
          }
      });
      const variantData =  JSON.parse(this.querySelector('[type="application/json"]').textContent);
      variantData.forEach(variant => {
        variant.options.forEach(option => {
          if(option.includes(selectedValue)){
             selectedID = variant.id;
          }
          if(option.includes(selectedValue)){
            console.log(selectedID, "selectedID");
            if(variant.available){
              addToCartButton.removeAttribute('disabled');
              addtoCartAddText.classList.remove("hidden");
              addtocartSoloutText.classList.add("hidden");
            }
            if(!variant.available){
              addToCartButton.setAttribute('disabled', 'disabled');
              addtoCartAddText.classList.add("hidden");
              addtocartSoloutText.classList.remove("hidden");
            }
          }
        });
      });
      this.renderProductInfoCustome(selectedID); 

    });
  }

  renderProductInfoCustome(selectedID) {
    if(!selectedID) return;
    const requestedVariantId = selectedID;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${selectedID}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (selectedID !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          //!this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));
    
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      const optionsMatch = variant.options.every(
        (option, index) => option === this.options[index]
      );
      return optionsMatch;
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('variant', this.currentVariant.id);
    
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({ path: newUrl }, '', newUrl);
  
  }


  updateVariantInput() {
    if (!this.currentVariant) return;
    
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updateVariantStatuses() {
    if (!this.currentVariant) return;

    const selectedVariant = this.currentVariant;
    
    const selects = this.querySelectorAll('select.js-sticky-variants');
    
    selects.forEach((select, index) => {
      const wrapper = select.closest('.product-form__input');
      const customSelect = wrapper.querySelector('.custom-select');
      const optionList = wrapper.querySelector('.select-options');
      
      if (customSelect && optionList) {
        const listItems = optionList.querySelectorAll('li');
        listItems.forEach(item => {
          const value = item.getAttribute('rel');
          const isAvailable = this.getVariantData().some(variant => 
            variant.options[index] === value && variant.available
          );
          
          item.classList.toggle('unavailable', !isAvailable);
          item.classList.toggle('disabled', !isAvailable);
        });
      }
    });
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    
    if (!this.currentVariant) {
      this.setUnavailable();
      return;
    }

    this.updateURL();
    this.updateVariantInput();
    this.updateVariantStatuses();
    this.updateMedia();
    this.updateMediaSub();
    this.renderProductInfo();
  }

  updateOptions() {
    //this.options = Array.from(
    //	this.querySelectorAll("select"),
    //	(select) => select.value
    //); 
    const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );    
    const options = this.getOptionsStatus()  
                 
  }   

  getOptionsStatus() {
    const options = [
      ...Array.from(this.querySelectorAll("select")).flatMap(select =>
          Array.from(select.options).map(option => ({
              value: option.value,
              available: option.selected
          }))
      ),
      ...Array.from(this.querySelectorAll("fieldset")).flatMap(fieldset =>
          Array.from(fieldset.querySelectorAll("input[type='radio']")).map(radio => ({
              value: radio.value,
              available: radio.checked
          }))
      )
  ];
  return options                         
}

  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        this.options.sort();
        variant.options.sort();

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    const parent = newMedia.parentElement;

    parent.prepend(newMedia);

    window.setTimeout(() => {
      parent.scroll(0, 0);
    });

    if (document.querySelector(".js-media-list")) {
      sliderInit();
    }
  }

  updateMediaSub() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const newMediaSub = document.querySelector(
      `[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (
      document.querySelector(".js-media-sublist") &&
      document.querySelector(".js-media-sublist").swiper != null
    ) {
      document.querySelector(".js-media-sublist").swiper.destroy();
    }

    if (!newMediaSub) return;

    const parentSub = newMediaSub.parentElement;

    parentSub.prepend(newMediaSub);

    window.setTimeout(() => {
      parentSub.scroll(0, 0);
    });

    if (document.querySelector(".js-media-sublist")) {
      subSliderInit();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
    this.updateOptions();
     this.updateOptions();
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
 
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter( 
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option, li'),
      ];
      
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const value = input.getAttribute("value");
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
      
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        }
      } else {
        if (input.tagName === "OPTION") {
          // input.innerText =
          //   window.variantStrings.unavailable_with_option.replace(
          //     "[value]",
          //     input.getAttribute("value")
          //   );
            input.innerText  = input.innerText;
            const customVariantOption = document.querySelector(`.sticky-variants-select li[data-value="${value}"]`);
       
            if (customVariantOption) {
                customVariantOption.innerText = input.innerText;
            }
        } 
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    if(!this.currentVariant) return;
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          //!this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelectorAll(
      '[name="add"] > .add_to_cart_quantity'
    );
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");

      if (text) {
        addButtonText.forEach((elem) => {
          elem.innerHTML = `${text}`;
         
        });
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.forEach((elem) => {
        elem.innerHTML = `${window.variantStrings.addToCart}`;
      });
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelectorAll(
      '[name="add"] > .add_to_cart_quantity'
    );
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    //const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    //addButtonText.textContent = window.variantStrings.unavailable;
    //if (price) price.classList.add('visibility-hidden');
    addButtonText.forEach((elem) => {
      // elem.innerHTML = `${window.variantStrings.unavailable}`;
    });
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    //if (this.variantData || this.querySelector('[type="application/json"]')) {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
    //}
  }
}

customElements.define("sticky-variant-selects", StickyVariantSelects);

document.addEventListener("DOMContentLoaded", function () {
  // Get elements
  const productInfo = document.querySelector(".product.row .product-form .product-form__buttons .product-form__submit");
  const stickyATC = document.querySelector(".product-sticky-form"); // Ensure the correct selector
  const footer = document.querySelector("footer");

  // If elements are missing, exit
  if (!productInfo || !stickyATC || !footer) {
    console.log("Required elements not found");
    return;
  }

  // Apply transition
  stickyATC.style.transition = "opacity 0.2s ease-in-out, visibility 0.2s ease-in-out";

  let isProductVisible = true;
  let isFooterVisible = false;

  // Function to update visibility
  const updateStickyVisibility = () => {
    if (!isProductVisible && !isFooterVisible) {
      stickyATC.style.visibility = "visible";
      stickyATC.style.opacity = "1";
    } else {
      stickyATC.style.opacity = "0";
      stickyATC.style.visibility = "hidden";
    }
  };

  // Observer for product add-to-cart button
  const productObserver = new IntersectionObserver(
    (entries) => {
      isProductVisible = entries[0].isIntersecting;
      updateStickyVisibility();
    },
    { root: null, threshold: 0 }
  );

  // Observer for footer visibility
  const footerObserver = new IntersectionObserver(
    (entries) => {
      isFooterVisible = entries[0].isIntersecting;
      updateStickyVisibility();
    },
    { root: null, threshold: 0 }
  );

  productObserver.observe(productInfo);
  footerObserver.observe(footer);
});
